var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateRange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2516_24015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    y: 0.384521,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2516_24015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23117 9.78442C4.99917 9.78442 4.80539 9.70426 4.64984 9.54392C4.49428 9.38359 4.4165 9.18915 4.4165 8.96059C4.4165 8.73204 4.49495 8.5372 4.65184 8.37609C4.80884 8.21498 5.00328 8.13442 5.23517 8.13442C5.46717 8.13442 5.66095 8.21576 5.8165 8.37842C5.97206 8.54098 6.04984 8.73781 6.04984 8.96892C6.04984 9.19192 5.97139 9.38359 5.8145 9.54392C5.6575 9.70426 5.46306 9.78442 5.23117 9.78442ZM8.38117 9.78442C8.14917 9.78442 7.95539 9.70426 7.79984 9.54392C7.64428 9.38359 7.5665 9.18915 7.5665 8.96059C7.5665 8.73204 7.64495 8.5372 7.80184 8.37609C7.95884 8.21498 8.15328 8.13442 8.38517 8.13442C8.61717 8.13442 8.81095 8.21576 8.9665 8.37842C9.12206 8.54098 9.19984 8.73781 9.19984 8.96892C9.19984 9.19192 9.12139 9.38359 8.9645 9.54392C8.8075 9.70426 8.61306 9.78442 8.38117 9.78442ZM11.4145 9.78442C11.1825 9.78442 10.9887 9.70426 10.8332 9.54392C10.6776 9.38359 10.5998 9.18915 10.5998 8.96059C10.5998 8.73204 10.6783 8.5372 10.8352 8.37609C10.9922 8.21498 11.1866 8.13442 11.4185 8.13442C11.6505 8.13442 11.8443 8.21576 11.9998 8.37842C12.1554 8.54098 12.2332 8.73781 12.2332 8.96892C12.2332 9.19192 12.1547 9.38359 11.9978 9.54392C11.8408 9.70426 11.6464 9.78442 11.4145 9.78442ZM1.9165 15.4678V2.28442H4.41984V1.28442H5.78317V2.28442H10.8832V1.28442H12.2532V2.28442H14.7665V15.4678H1.9165ZM3.48317 13.9011H13.1832V6.88442H3.48317V13.9011ZM3.48317 5.88442H13.1832V3.86776H3.48317V5.88442Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange);
export default __webpack_public_path__ + "static/media/date_range.b5009da7fa5b7ac8ea7b80dc033cb3c6.svg";
export { ForwardRef as ReactComponent };